import {ON_SIDEBAR_MODAL_BLUR, ON_SIDEBAR_MODAL_FOCUS, SIZE_CHANGED} from '../actions/type'
import {toReverseArray} from '../helper/objectSort'

const INITIAL_STATE = {
    width: window.innerWidth,
    focusedElements: [],
    _focusedElements: {},
}

// eslint-disable-next-line no-extend-native
Array.prototype.remove = function () {
    let i = arguments.length;
    let element;
    let k;

    while (i && this.length) {
        element = arguments[--i];
        while ((k = this.indexOf(element)) !== -1)
            this.splice(k, 1);
    }

    return this;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INITIAL_STATE, action) => {
    let focusedElements = []
    let _focusedElements = {}

    switch (action.type) {
        case SIZE_CHANGED:
            return {
                ...state,
                ...action.payload,
            }
        case ON_SIDEBAR_MODAL_FOCUS:
            _focusedElements = {
                ...state._focusedElements,
                [action.payload.time]: action.payload.id,
            }

            focusedElements = toReverseArray(_focusedElements)

            return {
                ...state,
                focusedElements,
                _focusedElements,
            }
        case ON_SIDEBAR_MODAL_BLUR:
            focusedElements = [...state.focusedElements]
            focusedElements.remove(action.payload)

            _focusedElements = {}
            Object.keys(state._focusedElements).forEach(key => {
                if (state._focusedElements[key] !== action.payload)
                    _focusedElements[key] = state._focusedElements[key]
            })

            return {
                ...state,
                _focusedElements,
                focusedElements,
            }
        default:
            return state
    }
}
